import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.input.background,
      borderRadius: constants.radius.view,
      paddingLeft: spacing.s,
      paddingRight: spacing.s,
      paddingTop: constants.divPadding,
      paddingBottom: constants.divPadding,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      cursor: "pointer",
      userSelect: "none",
    },
    content: {
      marginLeft: spacing.s,
      marginRight: spacing.s,
      flex: 1,
    },
    title: {
      margin: 0,
    },
    subtitle: {
      fontSize: 11,
      margin: 0,
      marginTop: spacing.xxs,
      color: theme.text.secondary,
    },
    exclusive: {
      marginLeft: spacing.s,
    },
    disabled: {
      opacity: 0.5,
    },
  };

  return styles;
};
